import { CutlerySolidIcon } from '@ikyucom/design-system-icons-react'
import { twMerge } from 'tailwind-merge'
import { FilterChip } from './FilterChip'
import { createColor } from './criteria'
import type { FilterCriteria } from './types'

export type UseSetBuffet = () => (buffet: boolean) => void

export function Buffet({
  useFilterCriteria,
  useBuffet,
  useSetBuffet,
  useEnabledBuffet,
}: {
  useFilterCriteria: () => FilterCriteria | undefined
  useBuffet: () => boolean
  useSetBuffet: UseSetBuffet
  useEnabledBuffet: () => boolean
}) {
  const set = useSetBuffet()
  const criteria = useFilterCriteria()
  const hasBuffet = useBuffet()
  const enabled = useEnabledBuffet()
  const color = createColor({ enabled, isActive: criteria?.buffet })
  if (!hasBuffet) {
    return null
  }

  return (
    <FilterChip onClick={() => set(!criteria?.buffet)} color={color}>
      <div className="flex items-center gap-1">
        <CutlerySolidIcon
          width={13}
          height={13}
          className={twMerge(criteria?.buffet ? 'text-marron-light' : 'text-neutral-600')}
        />
        食べ放題（ビュッフェ）
      </div>
    </FilterChip>
  )
}
